module.exports = __webpack_public_path__ + "static/media/OCC_Amazon1._CB423492668_.73da3c08.jpg";